module.exports = __webpack_public_path__ + "img/1528362899.6e05715e.jpg";